export enum AreaTypeEnum {
    Inclusion = 1,
    Exclusion = 2,
}